import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import { Card } from "reactstrap";
import FirstStep from "../components/FirstStep";
import ErrorAlert from "../../../components/Modals/ErrorAlert";
import SecondStep from "../components/SecondStep";
import ThirdStep from "../components/ThirdStep";
import FourthStep from "../components/FourthStep";
import FifthStep from "../components/FifthStep";
import { createCaso, getDefaultParams } from "../../../actions/create";
import { getCasesAndProjects } from "../../../actions/cases";
import { UPDATE_CREATE_PARAMS } from "../../../actions/types";
import store from "../../../../store";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return [
    "Technologies",
    "Load",
    "Efficiency & Taxes",
    "Environment",
    "Create",
  ];
}

function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return <FirstStep></FirstStep>;
    case 1:
      return <SecondStep></SecondStep>;
    case 2:
      return <ThirdStep></ThirdStep>;
    case 3:
      return <FourthStep></FourthStep>;
    case 4:
      return <FifthStep></FifthStep>;
    default:
      return "Loading...";
  }
}

export const CreateCase = (props) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  useEffect(() => {
    return () => {
      store.dispatch({
        type: UPDATE_CREATE_PARAMS,
        payload: { key: "simulation_type", value: null },
      });
      store.dispatch({
        type: UPDATE_CREATE_PARAMS,
        payload: { key: "geometry", value: null },
      });
    };
  }, []);

  const handleNext = async (setDefault, setActive) => {
    if (activeStep === steps.length - 1) {
      if (props.create.label === "") {
        ErrorAlert("Label is compulsory");
      } else {
        props.createCaso(
          props.create,
          props.history,
          props.getCasesAndProjects,
          props.getDefaultParams
        );
      }
    } else if (activeStep < steps.length - 1) {
      if (activeStep === 0) {
        if (props.create.PV_run === false && props.create.WT_run === false) {
          ErrorAlert("At least one from PV and WT must be chosen");
        } else {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
      } else if (activeStep === 1) {
        if (props.create.load === null) {
          ErrorAlert("Choose a Load from the list");
        } else {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div style={{ padding: "20px 20px 0px 20px" }}>
      {props.create.simulation_type === null ? (
        <div
          style={{
            height: "95vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Choose a point to create a new case
        </div>
      ) : (
        <React.Fragment>
          <h3 style={{ marginTop: 20, marginBottom: 35 }}>Create a new case</h3>
          <Card style={{ padding: "0px 20px 20px 20px" }}>
            <div className={classes.root}>
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                style={{ backgroundColor: "transparent" }}
              >
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div>
                {activeStep === steps.length ? (
                  <div>
                    <Typography className={classes.instructions}>
                      All steps completed
                    </Typography>
                    <Button onClick={handleReset}>Reset</Button>
                  </div>
                ) : (
                  <div style={{ marginTop: "0px" }}>
                    {getStepContent(activeStep)}
                    <div style={{ marginTop: "20px" }}>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.backButton}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleNext(false, false)}
                      >
                        {activeStep === steps.length - 1 ? "Create" : "Next"}
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Card>
        </React.Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  create: state.create,
});

export default connect(mapStateToProps, {
  createCaso,
  getCasesAndProjects,
  getDefaultParams,
})(CreateCase);
